<!DOCTYPE html>
<template>

<div>
  <ClientDashboard v-if="isClient"
                   :projectId="projectId"
                   :user="user" />
  <ProviderDashboard v-if="isProvider"
                     :projectId="projectId"
                     :user="user" />


</div>
</template>

<script>
//Firebase
const firebase = require( '@/firebaseConfig.js' )
const users = firebase.db.collection( 'users' )
//Components
import ClientDashboard from '@/views/ClientDashboard.vue'
import ProviderDashboard from '@/views/ProviderDashboard.vue'
export default {
  name: 'Dashboard',
  components: {
    ClientDashboard,
    ProviderDashboard,
  },
  props: {
    user: Object,
    projectId: String,

  },
  data() {
    return {
      userRef: null,
      userData: null,
    }
  },
  watch: {
    user: {
      // call it upon creation too
      immediate: true,
      handler( user ) {
        if ( user ) {
          this.userRef = users.doc( user.uid )
          this.$bind( 'userData', this.userRef )
        }
      },
    },
  },
  computed: {
    isClient() {
      if ( this.userData ) {
        return this.userData.type === 'client'
      }
      return false
    },
    isProvider() {
      if ( this.userData ) {
        return this.userData.type === 'provider'
      }
      return false
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
</style>
